/** 非庫存採購單狀態。沒有部分收貨／已收貨。 */

export const MISC_PURCHASE_ORDER_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  CLOSED: 'CLOSED',
  TERMINATED: 'TERMINATED',
  CANCELLED: 'CANCELLED',
};

export const MISC_PURCHASE_ORDER_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  APPROVED: '已核准',
  CLOSED: '已結案',
  TERMINATED: '已中止',
  CANCELLED: '已取消',
};

export const MISC_PURCHASE_ORDER_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'SUBMITTED', label: '已提交' },
  { value: 'APPROVED', label: '已核准' },
  { value: 'CLOSED', label: '已結案' },
  { value: 'TERMINATED', label: '已中止' },
  { value: 'CANCELLED', label: '已取消' },
];

export function formatMiscPurchaseOrderStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return MISC_PURCHASE_ORDER_STATUS_LABELS[status] ?? status;
}

export function canEditMiscPurchaseOrderDraft(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.DRAFT;
}

export function canSubmitMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.DRAFT;
}

export function canCancelDraftMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.DRAFT;
}

export function canApproveMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.SUBMITTED;
}

export function canRejectMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.SUBMITTED;
}

export function canCloseMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.APPROVED;
}

/** 中止：僅 APPROVED；有在途異動時後端回 409，原因必填。 */
export function canTerminateMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.APPROVED;
}

export function canAmendMiscPurchaseOrder(status) {
  return status === MISC_PURCHASE_ORDER_STATUS.APPROVED;
}
